import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Dialog, DialogType, DialogFooter, PrimaryButton, DefaultButton, Spinner, SpinnerSize } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';

export const getStyles = (useless, { palette }) => ({
  deleteDialog: {
    '& .error-message': {
      color: palette.redDark,
      marginBottom: 16,
    },
  },
});

export const DeleteDialog = (props) => {
  const {
    title, description, open, deleting, onConfirm, onDismiss, error,
  } = props;
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);

  const dialogContentProps = {
    type: DialogType.normal,
    title,
    subText: description,
    closeButtonAriaLabel: i18n.getString(_TL_('Close')),
  };

  const modalProps = {
    isBlocking: true,
    className: classNames(classes.deleteDialog, 'delete-dialog'),
  };

  return (
    <Dialog
      hidden={!open}
      onDismiss={onDismiss}
      dialogContentProps={dialogContentProps}
      modalProps={modalProps}
    >
      {error && <div className="error-message">{error}</div>}
      <DialogFooter>
        <PrimaryButton className="confirm-button" onClick={onConfirm} disabled={deleting}>
          {deleting ? <Spinner size={SpinnerSize.xSmall} /> : i18n.getString(_TL_('Delete'))}
        </PrimaryButton>
        <DefaultButton className="cancel-button" onClick={onDismiss}>
          {i18n.getString(_TL_('Cancel'))}
        </DefaultButton>
      </DialogFooter>
    </Dialog>
  );
};

DeleteDialog.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  deleting: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  error: PropTypes.string,
};

DeleteDialog.defaultProps = {
  error: null,
};
